
import { Box, Button, IconButton, Toolbar, Typography } from '@mui/material';
// import {pokedex} from '../helpers/DataHelper';
import { getAssetImagesUrl, getAssetData } from '../api/ApiDataHelper';
import { useTheme } from '@emotion/react';
import { Fragment, useEffect, useState } from 'react';
import { Trans, Translation, useTranslation } from 'react-i18next';
import { pokedex } from '../helpers/DataHelper';
import { useDispatch } from 'react-redux';
import { setCurrentLinks } from '../slices/themeSlice';
import { GridView } from '@mui/icons-material';
import { transform } from 'lodash';
import AppsIcon from '@mui/icons-material/Apps';
import ViewListIcon from '@mui/icons-material/ViewList';
import Footer from '../components/home/Footer';
import ScrollTop from '../components/layout/ScrollTop';

export default function PokedexPage(params) {
  const theme = useTheme();


  const [pokedexTemp, setPokedex] = useState(null);
  const [collected, setCollected] = useState(0);

  const [visibleOwneds, setVisibleOwneds] = useState(true);
  const [visibleMissings, setVisibleMissings] = useState(true);

  const [gridView, setGridView] = useState(true);

  const dispatch = useDispatch();

  useEffect(() => {
    const fetchPokedex = async () => {
      const response = await fetch(getAssetData("pokedexData.json"));
      const pokedex = await response.json()
      setPokedex(pokedex);
      // console.log(pokedex);
      const currentLinks = [
        { id: "back-to-top-anchor", title: t("label_top") },
        { id: "back-to-bottom-anchor", title: t("label_bottom") }
      ]
      let tempCollected = 0;
      pokedex.pokemons.map((pokemon, index) => {
        if (pokemon.collection.base || pokemon.collection.fossil || pokemon.collection.jungle || pokemon.collection.rocket) {
          tempCollected++
        }
        // if ((index) % 9 === 0 && index !== 0) {
        //   currentLinks.push({ id: "page_id_" + parseInt(index / 9), title: "Pag." + parseInt(index / 9) })
        // }
        return tempCollected;
      });
      setCollected(tempCollected);
      dispatch(setCurrentLinks(currentLinks))
      // console.log(currentLinks);
    }

    fetchPokedex();
  }, []);

  const { t } = useTranslation();

  const handleUpdateCollection = (id, collection, value) => {
    if (process.env.REACT_APP_POKEDEX_EDITABLE === "true") {
      let tempPokedex = structuredClone(pokedexTemp);
      let index = tempPokedex.pokemons.findIndex(pokemon => pokemon.id === id);
      tempPokedex.pokemons[index].collection[collection] = value;
      setPokedex(tempPokedex);
    }
  }

  const copyContent = async () => {
    try {
      await navigator.clipboard.writeText(JSON.stringify(pokedexTemp));
      console.log('Content copied to clipboard');
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  }


  return (
    <Box sx={{
      pt: "80px",
      minHeight: "100svh",
      display: "flex",
      flexDirection: "column",
    }}>
      <Toolbar id="back-to-top-anchor" />

      <Box sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        p: 3,
        "& img": {
          width: "40%",
          height: "auto",
          mb: 2,
        },
        [theme.breakpoints.down('sm')]: {
          "& img": {
            width: "80%",
          }
        }
      }}>
        <img src={getAssetImagesUrl("International_Pokémon_logo.svg")} alt="pokedex" />
        <Typography variant="h6" align='center' sx={{
          span: {
            whiteSpace: "nowrap",
          }
        }}>{t("label_pokedex_intro") + " "}<span>{process.env.REACT_APP_POKEDEX_LAST_EDIT}</span></Typography>
        <Box sx={{
          maxWidth: "80%",
          [theme.breakpoints.down('md')]: {
            maxWidth: "100%",
          }
        }}>
          <Typography vairant="body1" sx={{ my: 2 }}>
            <Trans i18nKey="label_pokedex_description" />
          </Typography>

          <Box sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
            mb: 2,
            ".chip-container": {
              p: "8px 16px",
              borderRadius: "24px",
              border: `2px solid ${theme.palette.primary.main}`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              img: {
                maxWidth: "40px",
                width: "100%",
                objectFit: "contain",
                mb: "0px",
                }
            }
          }}>
            <Box className="chip-container">
              <Typography variant='caption' align='center'>
                base
              </Typography>
            </Box>

            <Box className="chip-container">
              <img src={getAssetImagesUrl("icon-jungle.png")} alt="icon jungle" />
            </Box>

            <Box className="chip-container">
              <img src={getAssetImagesUrl("icon-fossil.png")} alt="icon jungle" />
            </Box>

            <Box className="chip-container">
              <img src={getAssetImagesUrl("icon-rocket.png")} alt="icon jungle" />
            </Box>

          </Box>
        </Box>
        <Box sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 2,
          width: "100%",
          flexDirection: "column",

        }}>
          <Box sx={{
            display: "flex",
            gap: 1,
            alignItems: "center",
            justifyContent: "center",
          }}>
            <Typography variant="h4" align='center'>{t("label_change_view")} →</Typography>
            <Button variant="contained" disableElevation sx={{ p: 1 }} onClick={() => { setGridView(!gridView) }} size='large'>
              {!gridView ? <AppsIcon fontSize="medium" /> : <ViewListIcon fontSize="medium" />}
            </Button>
          </Box>
          <Box sx={{
            display: "flex",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
            "& .value": {
              p: 2,
              cursor: "pointer",
              userSelect: "none",
              "&.collected": {
                border: `2px solid ${theme.palette.primary.main}`,
                color: theme.palette.primary.main,
                background: theme.palette.primary.main + "11",
                fontWeight: "bold",
                borderRadius: "48px 0px 0px 48px",
                transformOrigin: "center right",
                transition: "all 0.1s ease-in",
                "&:hover": {
                  transform: "scale(1.1)",
                },
                "&.active": {
                  background: theme.palette.primary.main,
                  color: theme.palette.common.white,
                }
              },
              "&.missing": {
                border: `2px solid ${theme.palette.error.main}`,
                color: theme.palette.error.main,
                background: theme.palette.error.main + "11",
                fontWeight: "bold",
                borderRadius: "0px 48px 48px 0px",
                transformOrigin: "center left",
                transition: "all 0.1s ease-in",
                "&:hover": {
                  transform: "scale(1.1)",
                },
                "&.active": {
                  background: theme.palette.error.main,
                  color: theme.palette.common.white,
                }
              }
            }
          }}>
            <Box onClick={() => { setVisibleOwneds(!visibleOwneds) }} className={visibleOwneds ? 'value collected active' : 'value collected'} >
              <Typography variant="h5"><strong>{t("label_collected") + ": " + collected}</strong></Typography>
            </Box>
            <Box onClick={() => { setVisibleMissings(!visibleMissings) }} className={visibleMissings ? 'value missing active' : 'value missing'} >
              <Typography variant="h5"><strong>{t("label_missing") + ": " + (151 - collected)}</strong></Typography>
            </Box>
          </Box>
        </Box>
      </Box>
      {
        process.env.REACT_APP_POKEDEX_EDITABLE === "true" &&
        <Box sx={{
          display: "flex",
          p: 3,
        }}>
          <Button variant='outlined' onClick={copyContent}>export json</Button>
        </Box>
      }

      <Box sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 2,
        p: 3,
        mx: "auto",
        maxWidth: "80%",
        userSelect: "none",
        flexDirection: gridView ? "row" : "column",
        "& .pokemon-card": {
          position: "relative",
          width: gridView ? `calc(calc(100% - ${8 * 2 * 2}px)/ 3)` : "100%",
          p: 3,
          outline: `2px solid ${theme.palette.error.main}`,
          borderRadius: "40px",
          display: visibleMissings ? "flex" : "none",
          flexDirection: gridView ? "column" : "row",
          gap: gridView ? 0 : 4,
          ".img-container": {
            width: gridView ? "100%" : "20%",
            [theme.breakpoints.down('md')]: {
              width: gridView ? "100%" : "33%",
            },
          },
          ".info-container": {
            width: gridView ? "100%" : "80%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: gridView ? "center" : "flex-start",
            ".num": {
              fontSize: gridView ? "3vw" : "4vw",
            },
            ".name": {
              fontSize: gridView ? "3vw" : "6vw",
            },
            [theme.breakpoints.down('md')]: {
              width: gridView ? "100%" : "66%",
              ".num": {
                fontSize: gridView ? "6vw" : "6vw",
              },
              ".name": {
                fontSize: gridView ? "4vw" : "8vw",
              },
            }
          },
          img: {
            width: "100%",
            height: "auto",
            filter: "grayscale(100%)",
          },
          "&.owned": {
            display: visibleOwneds ? "flex" : "none",
            outline: `2px solid ${theme.palette.primary.main}`,
            "& img": {
              filter: "grayscale(0%)",
            }
          },
          ".types-container": {
            display: "flex",
            alignItems: "center",
            justifyContent: process.env.REACT_APP_POKEDEX_EDITABLE === "true" ? "space-between" : "flex-start",
            flexWrap: "wrap",
            mb: 1,
            position: process.env.REACT_APP_POKEDEX_EDITABLE === "true" ? "static" : "absolute",
            top: "0px",
            gap: 1,
            flexDirection: process.env.REACT_APP_POKEDEX_EDITABLE === "true" ? "row" : "row-reverse",
            left: "0px",
            right: "0px",
            p: gridView ? 0 : 3,
            [theme.breakpoints.down('sm')]: {
              p: gridView ? 0 : 1,
            },
            "& .type": {
              cursor: process.env.REACT_APP_POKEDEX_EDITABLE === "true" ? "pointer" : "default",
              display: process.env.REACT_APP_POKEDEX_EDITABLE === "true" ? "flex" : "none",
              alignItems: "center",
              p: 1,
              borderRadius: "24px",
              img: {
                maxWidth: "24px",
                maxHeight: "24px",
              }
            },
            "&  .active": {
              background: `${theme.palette.primary.main}`,
              display: "flex",
            },
          },
        },
        ".page": {
          display: visibleOwneds && visibleMissings && gridView ? "block" : "none",
          width: "100%",
          p: 3,
        },
        [theme.breakpoints.down('md')]: {
          maxWidth: "100%",
          gap: 1,
          "& .pokemon-card": {
            width: gridView ? `calc(calc(100% - ${8 * 1 * 2}px)/ 3)` : "100%",
            p: 1,
            borderRadius: "24px",
          }
        }
      }}>
        {
          pokedexTemp ?
            pokedexTemp.pokemons.map((pokemon, index) => {

              return (
                <Fragment key={pokemon.id}>
                  {
                    (index) % 9 === 0 && index !== 0 ?
                      <Box className="page" key={"page" + index} id={"page_id_" + parseInt(index / 9)}>
                        <Typography variant="h3" align='center'>Pag.{parseInt(index / 9)}</Typography>
                      </Box>
                      :
                      ""
                  }
                  <Box
                    className={
                      pokemon.collection.base ||
                        pokemon.collection.fossil ||
                        pokemon.collection.jungle ||
                        pokemon.collection.rocket ||
                        pokemon.collection.holo
                        ?
                        "pokemon-card owned" :
                        "pokemon-card"}
                    key={pokemon.id}
                  >
                    <Box
                      className="img-container"
                      sx={{
                        position: gridView ? "relative" : "static",
                      }}>
                      <img src={getAssetImagesUrl("pokemon_images/" + pokemon.img)} alt={pokemon.name} />
                      <Box className="types-container">
                        <Box
                          onClick={() => {
                            handleUpdateCollection(pokemon.id, "base", !pokemon.collection.base);
                          }}
                          className={pokemon.collection.base ? "type active" : "type"}>
                          <Typography variant="caption">
                            base
                          </Typography>
                        </Box>
                        <Box
                          onClick={() => {
                            handleUpdateCollection(pokemon.id, "jungle", !pokemon.collection.jungle);
                          }}
                          className={pokemon.collection.jungle ? "type active" : "type"}>
                          <img src={getAssetImagesUrl("icon-jungle.png")} alt="icon jungle" />
                        </Box>
                        <Box
                          onClick={() => {
                            handleUpdateCollection(pokemon.id, "fossil", !pokemon.collection.fossil);
                          }}
                          className={pokemon.collection.fossil ? "type active" : "type"}>
                          <img src={getAssetImagesUrl("icon-fossil.png")} alt="icon jungle" />
                        </Box>
                        <Box
                          onClick={() => {
                            handleUpdateCollection(pokemon.id, "rocket", !pokemon.collection.rocket);
                          }}
                          className={pokemon.collection.rocket ? "type active" : "type"}>
                          <img src={getAssetImagesUrl("icon-rocket.png")} alt="icon jungle" />
                        </Box>
                        <Box
                          onClick={() => {
                            handleUpdateCollection(pokemon.id, "holo", !pokemon.collection.holo);
                          }}
                          className={pokemon.collection.holo ? "type active" : "type"}>
                          <Typography variant="caption">
                            holo
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                    <Box className="info-container" sx={{
                      display: "flex",
                      flexDirection: "column",
                    }}>
                      <Typography className="num" sx={{ lineHeight: 1 }} align='center'>{"#" + pokemon.num}</Typography>
                      <Typography className="name" sx={{ lineHeight: 1 }} align='center'>{pokemon.name}</Typography>
                    </Box>

                  </Box>
                </Fragment>
              )
            })
            :
            <Box sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}>
              <Typography variant="h3" align='center'>{t("label_retriving_data")}</Typography>
            </Box>
        }
        <Box sx={{
          width: "100%",
          display: !visibleMissings && !visibleOwneds ? "flex" : "none",
          justifyContent: "center",
          alignItems: "center",
        }}>
          <Typography variant="h3" align='center'>{t("label_no_item_to_show")}</Typography>
        </Box>

      </Box>
      <Toolbar id="back-to-bottom-anchor" />
      <ScrollTop />
      <Footer />
    </Box >
  )
}
